import Vue from 'vue';
import Router from 'vue-router';

import bhumie_home from '@/components/bhumie/home/home';

import bhumie_copy_data_pendukung_penilaian from '@/components/bhumie/pendataan/persiapan/copy_data_pendukung_penilaian';
import bhumie_pembuatan_ZNT from '@/components/bhumie/pendataan/persiapan/pembuatan_ZNT';
import bhumie_pembuatan_nilai_bangunan from '@/components/bhumie/pendataan/persiapan/pembuatan_nilai_bangunan';
import bhumie_pembuatan_dbkb_standard from '@/components/bhumie/pendataan/persiapan/pembuatan_dbkb_standard';
import bhumie_pembuatan_dbkb_non_standard from '@/components/bhumie/pendataan/persiapan/pembuatan_dbkb_non_standard';

import bhumie_SPOP_LSPOP from '@/components/bhumie/pendataan/objek_pajak/SPOP_LSPOP';
import bhumie_jln_standard from '@/components/bhumie/pendataan/objek_pajak/jln_standard';

import bhumie_sk_kepala_daerah from '@/components/bhumie/pendataan/laporan/sk_kepala_daerah';
import bhumie_dhr from '@/components/bhumie/pendataan/laporan/dhr';
import bhumie_data_referensi from '@/components/bhumie/pendataan/laporan/data_referensi';

import bhumie_hapus_data_sistem from '@/components/bhumie/pendataan/sistep/hapus_data_sistem';
import bhumie_reklas from '@/components/bhumie/pendataan/sistep/reklas';

import bhumie_pemekaran_wilayah from '@/components/bhumie/pendataan/pemekaran_wilayah/pemekaran_wilayah';

import bhumie_laporan_penilaian from '@/components/bhumie/penilaian/laporan_penilaian';
import bhumie_proses_penilaian_massal from '@/components/bhumie/penilaian/proses_penilaian_massal';

import bhumie_pbb_minimal from '@/components/bhumie/penetapan/pbb_minimal';
import bhumie_penetapan_pencetakan_massal from '@/components/bhumie/penetapan/penetapan_pencetakan_massal';
import bhumie_penetapan_pencetakan_terseleksi from '@/components/bhumie/penetapan/penetapan_pencetakan_terseleksi';
import bhumie_salinan_massal from '@/components/bhumie/penetapan/salinan_massal';
import bhumie_simulasi_penetapan_massal from '@/components/bhumie/penetapan/simulasi_penetapan_massal';
import bhumie_tanda_terima_SPPT_STP from '@/components/bhumie/penetapan/tanda_terima_SPPT_STP';

import bhumie_daftar_tunggakan from '@/components/bhumie/penagihan/daftar_tunggakan';
import bhumie_pengeluaran_himbauan from '@/components/bhumie/penagihan/pengeluaran_himbauan';

import bhumie_laporan_pembayaran from '@/components/bhumie/pembayaran/laporan_pembayaran/laporan_pembayaran';
import bhumie_pembatalan_tunggal from '@/components/bhumie/pembayaran/pembatalan/pembatalan_tunggal';
import bhumie_perekaman_massal from '@/components/bhumie/pembayaran/perekaman/perekaman_massal';
import bhumie_perekaman_tunggal from '@/components/bhumie/pembayaran/perekaman/perekaman_tunggal';
import bhumie_cetak_massal from '@/components/bhumie/pembayaran/surat_keterangan_pembayaran/cetak_massal';
import bhumie_cetak_tunggal from '@/components/bhumie/pembayaran/surat_keterangan_pembayaran/cetak_tunggal';

import bhumie_adm_op_baru_mutasi from '@/components/bhumie/pelayanan/adm_op_baru_mutasi/adm_op_baru_mutasi';
import bhumie_cetak_file_keluaran from '@/components/bhumie/pelayanan/cetak_file_keluaran/cetak_file_keluaran';
import bhumie_cetak_tanda_terima from '@/components/bhumie/pelayanan/cetak_tanda_terima/cetak_tanda_terima';
import bhumie_input_permohonan from '@/components/bhumie/pelayanan/input_permohonan/input_permohonan';
import bhumie_input_sk_atas_keberatan_pbb from '@/components/bhumie/pelayanan/keberatan/input_sk_atas_keberatan_pbb';
import bhumie_proses_sk_atas_keberatan_pbb from '@/components/bhumie/pelayanan/keberatan/proses_sk_atas_keberatan_pbb';
import bhumie_parameter_keluaran_pelayanan from '@/components/bhumie/pelayanan/parameter_keluaran_pelayanan/parameter_keluaran_pelayanan';
import bhumie_input_sk_kolektif_pembatalan from '@/components/bhumie/pelayanan/pembatalan_SPPT/input_sk_kolektif_pembatalan';
import bhumie_input_sk_tunggal_pembatalan from '@/components/bhumie/pelayanan/pembatalan_SPPT/input_sk_tunggal_pembatalan';
import bhumie_proses_sk_kolektif_pembatalan from '@/components/bhumie/pelayanan/pembatalan_SPPT/proses_sk_kolektif_pembatalan';
import bhumie_proses_sk_tunggal_pembatalan from '@/components/bhumie/pelayanan/pembatalan_SPPT/proses_sk_tunggal_pembatalan';
import bhumie_input_sk_kolektif_pembetulan from '@/components/bhumie/pelayanan/pembetulan_SPPT/input_sk_kolektif_pembetulan';
import bhumie_input_sk_tunggal_pembetulan from '@/components/bhumie/pelayanan/pembetulan_SPPT/input_sk_tunggal_pembetulan';
import bhumie_proses_sk_kolektif_pembetulan from '@/components/bhumie/pelayanan/pembetulan_SPPT/proses_sk_kolektif_pembetulan';
import bhumie_proses_sk_tunggal_pembetulan from '@/components/bhumie/pelayanan/pembetulan_SPPT/proses_sk_tunggal_pembetulan';
import bhumie_input_data_pengurangan_pbb from '@/components/bhumie/pelayanan/pengurangan/input_data_pengurangan_pbb';
import bhumie_proses_sk_pengurangan_pbb from '@/components/bhumie/pelayanan/pengurangan/proses_sk_pengurangan_pbb';
import bhumie_penundaan_tgl_jatuh_tempo from '@/components/bhumie/pelayanan/penundaan_tgl_jatuh_tempo/penundaan_tgl_jatuh_tempo';
import bhumie_penyerahan_berkas_selesai_wp from '@/components/bhumie/pelayanan/penyerahan_berkas_pelayanan_selesai_wp/penyerahan_berkas_pelayanan_selesai_wp';
import bhumie_input_restitusi_kompensasi from '@/components/bhumie/pelayanan/restitusi_kompensasi/input_restitusi_kompensasi';
import bhumie_input_surat_pemberitaan from '@/components/bhumie/pelayanan/restitusi_kompensasi/input_surat_pemberitaan';
import bhumie_input_surat_pencabutan_SPMKP_pbb from '@/components/bhumie/pelayanan/restitusi_kompensasi/input_surat_pencabutan_SPMKP_pbb';
import bhumie_restitusi_kompensasi from '@/components/bhumie/pelayanan/restitusi_kompensasi/lap_restitusi_kompensasi';

import bhumie_buku_NJOPTK_tarif from '@/components/bhumie/referensi/buku_NJOPTK_tarif/buku_NJOPTK_tarif';
import bhumie_lap_harga_resource from '@/components/bhumie/referensi/harga_resource/lap_harga_resource';
import bhumie_update_harga_resource from '@/components/bhumie/referensi/harga_resource/update_harga_resource';
import bhumie_kepegawaian from '@/components/bhumie/referensi/kepegawaian/kepegawaian';
import bhumie_tempat_pembayaran from '@/components/bhumie/referensi/tempat_pembayaran/tempat_pembayaran';
import bhumie_tempat_pembayaran_SPPT_massal from '@/components/bhumie/referensi/tempat_pembayaran_SPPT_massal/tempat_pembayaran_SPPT_massal';
import bhumie_umum from '@/components/bhumie/referensi/umum/umum';

import bhumie_backup from '@/components/bhumie/admin/backup';
import bhumie_wewenang from '@/components/bhumie/admin/wewenang';
import bhumie_sms from '@/components/bhumie/admin/sms';



// import './assets/css/kiken/kiken.css'

Vue.use(Router)



function loggedInRedirectDashboard(to, from, next) {
  if (localStorage.token) {
    next('/dashboard');
  } else {
    next();
  }
}

function isLoggedIn(to, from, next) {
  if (localStorage.token) {
    next();
  } else {
    next('/monev_login');
  }
}

var routes = [
    {
        path: '/bhumie',
        name: '/bhumie',
        component: bhumie_home,
        beforeEnter: isLoggedIn,
    },

// =================================================== PENDATAAN ========================================================
    // ++++++++++++++++++++++++++ persiapan +++++++++++++++++++++++
    {
      path: '/bhumie_copy_data_pendukung_penilaian',
      name: '/bhumie_copy_data_pendukung_penilaian',
      component: bhumie_copy_data_pendukung_penilaian,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/bhumie_pembuatan_ZNT',
      name: '/bhumie_pembuatan_ZNT',
      component: bhumie_pembuatan_ZNT,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/bhumie_pembuatan_nilai_bangunan',
      name: '/bhumie_pembuatan_nilai_bangunan',
      component: bhumie_pembuatan_nilai_bangunan,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/bhumie_pembuatan_dbkb_standard',
      name: '/bhumie_pembuatan_dbkb_standard',
      component: bhumie_pembuatan_dbkb_standard,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/bhumie_pembuatan_dbkb_non_standard',
      name: '/bhumie_pembuatan_dbkb_non_standard',
      component: bhumie_pembuatan_dbkb_non_standard,
      beforeEnter: isLoggedIn,
    },
    // ++++++++++++++++++++++++++ persiapan +++++++++++++++++++++++

    // ++++++++++++++++++++++++++ Oyek Pajak +++++++++++++++++++++++
    {
      path: '/bhumie_SPOP_LSPOP',
      name: '/bhumie_SPOP_LSPOP',
      component: bhumie_SPOP_LSPOP,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/bhumie_jln_standard',
      name: '/bhumie_jln_standard',
      component: bhumie_jln_standard,
      beforeEnter: isLoggedIn,
    },
    // ++++++++++++++++++++++++++ Oyek Pajak +++++++++++++++++++++++

    // ++++++++++++++++++++++++++ Laporan +++++++++++++++++++++++
    {
      path: '/bhumie_sk_kepala_daerah',
      name: '/bhumie_sk_kepala_daerah',
      component: bhumie_sk_kepala_daerah,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/bhumie_dhr',
      name: '/bhumie_dhr',
      component: bhumie_dhr,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/bhumie_data_referensi',
      name: '/bhumie_data_referensi',
      component: bhumie_data_referensi,
      beforeEnter: isLoggedIn,
    },
    // ++++++++++++++++++++++++++ Laporan +++++++++++++++++++++++

    // ++++++++++++++++++++++++++ Sistep +++++++++++++++++++++++
    {
      path: '/bhumie_hapus_data_sistem',
      name: '/bhumie_hapus_data_sistem',
      component: bhumie_hapus_data_sistem,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/bhumie_reklas',
      name: '/bhumie_reklas',
      component: bhumie_reklas,
      beforeEnter: isLoggedIn,
    },
    // ++++++++++++++++++++++++++ Sistep +++++++++++++++++++++++

    // ++++++++++++++++++++++++++ Pemekaran Wilayah +++++++++++++++++++++++
    {
      path: '/bhumie_pemekaran_wilayah',
      name: '/bhumie_pemekaran_wilayah',
      component: bhumie_pemekaran_wilayah,
      beforeEnter: isLoggedIn,
    },
    // ++++++++++++++++++++++++++ Pemekaran Wilayah +++++++++++++++++++++++

// =================================================== PENDATAAN ========================================================    

// =================================================== PENILAIAN ========================================================    
    {
      path: '/bhumie_laporan_penilaian',
      name: '/bhumie_laporan_penilaian',
      component: bhumie_laporan_penilaian,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/bhumie_proses_penilaian_massal',
      name: '/bhumie_proses_penilaian_massal',
      component: bhumie_proses_penilaian_massal,
      beforeEnter: isLoggedIn,
    },
// =================================================== PENILAIAN ========================================================    

// =================================================== PENETAPAN ========================================================    
    {
      path: '/bhumie_pbb_minimal',
      name: '/bhumie_pbb_minimal',
      component: bhumie_pbb_minimal,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/bhumie_penetapan_pencetakan_massal',
      name: '/bhumie_penetapan_pencetakan_massal',
      component: bhumie_penetapan_pencetakan_massal,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/bhumie_penetapan_pencetakan_terseleksi',
      name: '/bhumie_penetapan_pencetakan_terseleksi',
      component: bhumie_penetapan_pencetakan_terseleksi,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/bhumie_salinan_massal',
      name: '/bhumie_salinan_massal',
      component: bhumie_salinan_massal,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/bhumie_simulasi_penetapan_massal',
      name: '/bhumie_simulasi_penetapan_massal',
      component: bhumie_simulasi_penetapan_massal,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/bhumie_tanda_terima_SPPT_STP',
      name: '/bhumie_tanda_terima_SPPT_STP',
      component: bhumie_tanda_terima_SPPT_STP,
      beforeEnter: isLoggedIn,
    },
// =================================================== PENETAPAN ========================================================    

// =================================================== PENETAPAN ========================================================    
    {
      path: '/bhumie_daftar_tunggakan',
      name: '/bhumie_daftar_tunggakan',
      component: bhumie_daftar_tunggakan,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/bhumie_pengeluaran_himbauan',
      name: '/bhumie_pengeluaran_himbauan',
      component: bhumie_pengeluaran_himbauan,
      beforeEnter: isLoggedIn,
    },
// =================================================== PENETAPAN ========================================================   

// =================================================== PEMBAYARAN ========================================================    
    {
      path: '/bhumie_laporan_pembayaran',
      name: '/bhumie_laporan_pembayaran',
      component: bhumie_laporan_pembayaran,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/bhumie_pembatalan_tunggal',
      name: '/bhumie_pembatalan_tunggal',
      component: bhumie_pembatalan_tunggal,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/bhumie_perekaman_massal',
      name: '/bhumie_perekaman_massal',
      component: bhumie_perekaman_massal,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/bhumie_perekaman_tunggal',
      name: '/bhumie_perekaman_tunggal',
      component: bhumie_perekaman_tunggal,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/bhumie_cetak_massal',
      name: '/bhumie_cetak_massal',
      component: bhumie_cetak_massal,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/bhumie_cetak_tunggal',
      name: '/bhumie_cetak_tunggal',
      component: bhumie_cetak_tunggal,
      beforeEnter: isLoggedIn,
    },
// =================================================== PEMBAYARAN ========================================================    
  
// =================================================== PELAYANAN ========================================================
    {
        path: '/bhumie_adm_op_baru_mutasi',
        name: '/bhumie_adm_op_baru_mutasi',
        component: bhumie_adm_op_baru_mutasi,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/bhumie_cetak_file_keluaran',
        name: '/bhumie_cetak_file_keluaran',
        component: bhumie_cetak_file_keluaran,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/bhumie_cetak_tanda_terima',
        name: '/bhumie_cetak_tanda_terima',
        component: bhumie_cetak_tanda_terima,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/bhumie_input_permohonan',
        name: '/bhumie_input_permohonan',
        component: bhumie_input_permohonan,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/bhumie_input_sk_atas_keberatan_pbb',
        name: '/bhumie_input_sk_atas_keberatan_pbb',
        component: bhumie_input_sk_atas_keberatan_pbb,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/bhumie_proses_sk_atas_keberatan_pbb',
        name: '/bhumie_proses_sk_atas_keberatan_pbb',
        component: bhumie_proses_sk_atas_keberatan_pbb,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/bhumie_parameter_keluaran_pelayanan',
        name: '/bhumie_parameter_keluaran_pelayanan',
        component: bhumie_parameter_keluaran_pelayanan,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/bhumie_input_sk_kolektif_pembatalan',
        name: '/bhumie_input_sk_kolektif_pembatalan',
        component: bhumie_input_sk_kolektif_pembatalan,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/bhumie_input_sk_tunggal_pembatalan',
        name: '/bhumie_input_sk_tunggal_pembatalan',
        component: bhumie_input_sk_tunggal_pembatalan,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/bhumie_proses_sk_kolektif_pembatalan',
        name: '/bhumie_proses_sk_kolektif_pembatalan',
        component: bhumie_proses_sk_kolektif_pembatalan,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/bhumie_proses_sk_tunggal_pembatalan',
        name: '/bhumie_proses_sk_tunggal_pembatalan',
        component: bhumie_proses_sk_tunggal_pembatalan,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/bhumie_input_sk_kolektif_pembetulan',
        name: '/bhumie_input_sk_kolektif_pembetulan',
        component: bhumie_input_sk_kolektif_pembetulan,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/bhumie_input_sk_tunggal_pembetulan',
        name: '/bhumie_input_sk_tunggal_pembetulan',
        component: bhumie_input_sk_tunggal_pembetulan,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/bhumie_proses_sk_kolektif_pembetulan',
        name: '/bhumie_proses_sk_kolektif_pembetulan',
        component: bhumie_proses_sk_kolektif_pembetulan,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/bhumie_proses_sk_tunggal_pembetulan',
        name: '/bhumie_proses_sk_tunggal_pembetulan',
        component: bhumie_proses_sk_tunggal_pembetulan,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/bhumie_input_data_pengurangan_pbb',
        name: '/bhumie_input_data_pengurangan_pbb',
        component: bhumie_input_data_pengurangan_pbb,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/bhumie_proses_sk_pengurangan_pbb',
        name: '/bhumie_proses_sk_pengurangan_pbb',
        component: bhumie_proses_sk_pengurangan_pbb,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/bhumie_penundaan_tgl_jatuh_tempo',
        name: '/bhumie_penundaan_tgl_jatuh_tempo',
        component: bhumie_penundaan_tgl_jatuh_tempo,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/bhumie_penyerahan_berkas_selesai_wp',
        name: '/bhumie_penyerahan_berkas_selesai_wp',
        component: bhumie_penyerahan_berkas_selesai_wp,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/bhumie_input_restitusi_kompensasi',
        name: '/bhumie_input_restitusi_kompensasi',
        component: bhumie_input_restitusi_kompensasi,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/bhumie_input_surat_pemberitaan',
        name: '/bhumie_input_surat_pemberitaan',
        component: bhumie_input_surat_pemberitaan,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/bhumie_input_surat_pencabutan_SPMKP_pbb',
        name: '/bhumie_input_surat_pencabutan_SPMKP_pbb',
        component: bhumie_input_surat_pencabutan_SPMKP_pbb,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/bhumie_restitusi_kompensasi',
        name: '/bhumie_restitusi_kompensasi',
        component: bhumie_restitusi_kompensasi,
        beforeEnter: isLoggedIn,
    },
  
// =================================================== PELAYANAN ========================================================    

// =================================================== PELAYANAN ========================================================   
    {
        path: '/bhumie_wewenang',
        name: '/bhumie_wewenang',
        component: bhumie_wewenang,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/bhumie_backup',
        name: '/bhumie_backup',
        component: bhumie_backup,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/bhumie_sms',
        name: '/bhumie_sms',
        component: bhumie_sms,
        beforeEnter: isLoggedIn,
    },
// =================================================== PELAYANAN ========================================================    
    {
      path: '/bhumie_kepegawaian',
      name: '/bhumie_kepegawaian',
      component: bhumie_kepegawaian,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/bhumie_tempat_pembayaran',
      name: '/bhumie_tempat_pembayaran',
      component: bhumie_tempat_pembayaran,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/bhumie_tempat_pembayaran_SPPT_massal',
      name: '/bhumie_tempat_pembayaran_SPPT_massal',
      component: bhumie_tempat_pembayaran_SPPT_massal,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/bhumie_update_harga_resource',
      name: '/bhumie_update_harga_resource',
      component: bhumie_update_harga_resource,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/bhumie_lap_harga_resource',
      name: '/bhumie_lap_harga_resource',
      component: bhumie_lap_harga_resource,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/bhumie_buku_NJOPTK_tarif',
      name: '/bhumie_buku_NJOPTK_tarif',
      component: bhumie_buku_NJOPTK_tarif,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/bhumie_umum',
      name: '/bhumie_umum',
      component: bhumie_umum,
      beforeEnter: isLoggedIn,
    },
// =================================================== REFERENSI ========================================================    

// =================================================== REFERENSI ========================================================    

  
  
  ]



export default routes